// Fire-and-forget audit logging for dispatch desk actions.
//
// Most dispatch scans never touch the BE on their own (item scans match
// locally against the open tote/order; box scans validate against the
// preloaded catalogue), so without this they leave no trace in the
// unified Logs page. POST /dispatch/scan-event exists purely to write
// that row — the BE middleware attaches the session user + warehouse
// and files barcode / order_id / tote_id / sku onto their indexed
// columns.
//
// Never awaited and never surfaced: a logging hiccup must not slow or
// break a scan.
import { apiFetch } from "../../api/apiFetch";

export type DispatchLogPayload = {
    /** kebab-case event slug, becomes the log action `dispatch.<event>` */
    event: string;
    /** outcome — start with "fail" to render as an error row (e.g.
     *  "fail-not-in-order"); anything else logs as success. */
    result?: string;
    barcode?: string;
    order_id?: string;
    tote_id?: string;
    sku?: string;
    /** picking mode that produced the unit being packed —
     *  "light" | "large" | "pick_and_sort" */
    pick_type?: string;
    desk_id?: string;
    /** anything else useful for debugging; lands in metadata */
    [key: string]: unknown;
};

export const logDispatchEvent = (payload: DispatchLogPayload): void => {
    try {
        apiFetch(`/dispatch/scan-event`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
        }).catch(() => { /* audit only */ });
    } catch { /* audit only */ }
};
